import { Button, Flex, Form, Input, Modal, Typography } from 'antd'
import React, { useState } from 'react'

import { LockOutlined } from '@ant-design/icons'

type PasswordModalProps = {
    isOpen: boolean
    onClose: () => void
    onSuccess: (password: string) => void | Promise<void>
    description?: string
    submitText?: string
}

export const PasswordModal: React.FC<PasswordModalProps> = ({
    isOpen,
    onClose,
    onSuccess,
    description = 'Enter your password to start setting up MFA.',
    submitText = 'Continue'
}) => {
    const [form] = Form.useForm<{ password: string }>()
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    const onFinish = async (values: { password: string }) => {
        try {
            setIsSubmitting(true)
            await onSuccess(values.password)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Modal open={isOpen} onCancel={onClose} footer={[]} destroyOnHidden>
            <Flex gap="middle" vertical>
                <Flex gap="xsmall" vertical>
                    <Typography.Title level={5}>Confirm your password</Typography.Title>
                    <Typography.Text>{description}</Typography.Text>
                </Flex>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Password"
                            autoComplete="current-password"
                            autoFocus
                        />
                    </Form.Item>
                    <Flex gap="small" justify="flex-end">
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="primary" htmlType="submit" loading={isSubmitting}>
                            {submitText}
                        </Button>
                    </Flex>
                </Form>
            </Flex>
        </Modal>
    )
}
